import {UI} from "../../../stem-core/src/ui/UIBase";

import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils";
import {CustomAmountButton} from "../CustomAmountButton.jsx";
import {DonateActiveButtonList} from "./DonateActiveButtonList";

export class DonateAmountButtonList extends DonateActiveButtonList {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            onCustomInputError: NOOP_FUNCTION,
            onValidCustomInput: NOOP_FUNCTION,
            customAmountButtonOptions: {
                currency: null,
                defaultCustomAmount: null,
                minAmount: null,
                maxAmount: null,
            },
        };
    }

    hasCustomAmountButton() {
        if (!this.options.customAmountButtonOptions) {
            return false;
        }

        // check if all the required custom amount button options are specified
        const {currency, minAmount, maxAmount} = this.options.customAmountButtonOptions;

        return currency && minAmount && maxAmount;
    }

    getTotalButtonsCount() {
        return super.getTotalButtonsCount() + (this.hasCustomAmountButton() ? 1 : 0);
    }

    getButtonElements() {
        const defaultButtonElements = super.getButtonElements();

        if (!this.hasCustomAmountButton()) {
            return defaultButtonElements;
        }

        const totalButtonsCount = this.getTotalButtonsCount();
        const {onCustomInputError, onValidCustomInput} = this.options;
        const {currency, minAmount, maxAmount, defaultCustomAmount} = this.options.customAmountButtonOptions;

        return [
            ...defaultButtonElements,
            <CustomAmountButton
                ref="customAmountButton"
                testId="customAmountButton"
                className={this.styleSheet.listItem}
                currency={currency} minAmount={minAmount} maxAmount={maxAmount}
                onInputError={onCustomInputError} onValidInput={onValidCustomInput}
                defaultAmount={currency.amountToMainUnits(defaultCustomAmount)}
                active={this.activeButtonIndex === totalButtonsCount - 1}
                onClick={() => {
                    this.updateActive(totalButtonsCount - 1);
                    this.handleCustomAmountChange(this.customAmountButton.getInputValue());
                }}
                onInputChange={(value) => this.handleCustomAmountChange(value)}
                onInputBlur={() => this.handleCustomAmountInputBlur()}/>
        ]
    }

    handleCustomAmountInputBlur() {
        const customAmountInputValue = this.customAmountButton.getInputValue();
        if (customAmountInputValue != null && customAmountInputValue.length === 0) {
            this.activeButtonIndex = null;
            this.redraw();
        }
    }

    handleCustomAmountChange(value) {
        const {onSelect, customAmountButtonOptions} = this.options;
        onSelect({amount: customAmountButtonOptions.currency.mainUnitsToAmount(value), isCustomAmount: true});
    }

    handleButtonClick(buttonIndex) {
        const {onSelect, items} = this.options;
        this.updateActive(buttonIndex);
        onSelect({amount: items[buttonIndex].value, isCustomAmount: false});
    }
}
